import type { LucideIcon } from "lucide-react";

export function Metric({
  label,
  value,
  icon: Icon,
}: {
  label: string;
  value: string;
  icon: LucideIcon;
}) {
  return (
    <div className="rounded-xl border border-stone-200 p-3 dark:border-white/10">
      <div className="flex items-center gap-2 text-[10px] font-bold tracking-wider text-stone-500 uppercase">
        <Icon size={14} />
        <span>{label}</span>
      </div>
      <div className="mt-2 text-lg font-bold tracking-tight">{value}</div>
    </div>
  );
}
